import React from 'react';
import { motion } from 'framer-motion';
import { Droplet, Timer, Utensils, Wind } from 'lucide-react';
const pillars = [{
  icon: Droplet,
  title: 'Hidratación Térmica',
  description: 'Activa tus células cada mañana.',
  color: 'text-blue-500',
  bg: 'bg-blue-50'
}, {
  icon: Timer,
  title: 'Secuencia de 5 Minutos',
  description: 'Movimientos clave, sin agotamiento.',
  color: 'text-[#F59E0B]',
  bg: 'bg-[#F59E0B]/10'
}, {
  icon: Utensils,
  title: 'Combinación de Alimentos',
  description: 'El orden correcto para evitar picos de insulina.',
  color: 'text-[#2D8C4E]',
  bg: 'bg-[#2D8C4E]/10'
}, {
  icon: Wind,
  title: 'Respiración Anti-Cortisol',
  description: 'Apaga el estrés antes de dormir.',
  color: 'text-purple-500',
  bg: 'bg-purple-50'
}];
export function MechanismSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-98">
      <div className="max-w-7xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-101">
            El Mecanismo de Despertar Secuencial
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-sans" data-id="element-102">
            Cuatro pilares diseñados específicamente para trabajar con la
            biología de la mujer, no en su contra.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-103">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-8 rounded-2xl bg-[#FDFAF6] border border-[#F0FDF4] hover:shadow-lg transition-shadow duration-300 group" data-id="element-104">
              <div className={`flex-shrink-0 w-14 h-14 rounded-xl ${pillar.bg} flex items-center justify-center mr-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-105">
                <pillar.icon className={`w-7 h-7 ${pillar.color}`} data-id="element-106" />
              </div>
              <div data-id="element-107">
                <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-108">
                  {pillar.title}
                </h3>
                <p className="text-gray-600 font-sans leading-relaxed" data-id="element-109">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}